import React, { useState } from 'react';
import { Card, CardContent } from '../../ui/card';
import { Collapsible, CollapsibleContent } from '../../ui/collapsible';
import { FileText } from 'lucide-react';
import { SectionHeader } from '../../common/OverviewHelpers';
import FileUpload from '../../common/FileUpload';

/**
 * Photos & Files section for the Account Overview tab.
 * Owns its own open/closed state.
 */
const AccountFilesSection = ({ account, onAccountUpdate }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card>
      <CardContent className="pt-6">
        <Collapsible open={open} onOpenChange={setOpen}>
          <SectionHeader
            title="Photos & Files"
            icon={FileText}
            isOpen={open}
            onToggle={() => setOpen(o => !o)}
          />
          <CollapsibleContent className="mt-4">
            <FileUpload
              tenantId={account.tenant_id}
              entityType="crm_entity"
              entityId={account.id}
              compact={false}
              currentProfilePhotoUrl={account.main_photo_url || ''}
              onProfilePhotoSet={(newUrl) => {
                if (onAccountUpdate) onAccountUpdate({ ...account, main_photo_url: newUrl });
              }}
            />
          </CollapsibleContent>
        </Collapsible>
      </CardContent>
    </Card>
  );
};

export default AccountFilesSection;
